import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#f8f6f4',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  minHeight: '100vh',
  padding: '6.25rem 0rem',
  [theme.breakpoints.up('md')]: {
    padding: '6.25rem 0rem',
  },
}));

export const BreadcrumbContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  padding: '0rem 1rem',

  [theme.breakpoints.up('lg')]: { padding: '0rem 10rem' },
  [theme.breakpoints.up('md')]: { padding: '0rem 5rem' },
}));

export const BreadcrumbLink = styled('a')(() => ({
  color: '#0e77da',
  fontSize: '0.75rem',
  fontWeight: 700,
  textDecoration: 'underline',
  cursor: 'pointer',
  fontFamily: "'Rookery new', sans-serif",
  lineHeight: '1rem',
}));

export const BreadcrumbText = styled(Typography)(() => ({
  color: '#5f5e60',
  fontSize: '0.75rem',
  fontWeight: 400,
  fontFamily: "'Rookery new', sans-serif",
  lineHeight: '1rem',
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  padding: '0rem 1rem',

  [theme.breakpoints.up('lg')]: { padding: '0rem 10rem' },
  [theme.breakpoints.up('md')]: { padding: '0rem 5rem' },
}));

export const Title = styled(Typography)(() => ({
  color: '#161c27',
  fontSize: '1.25rem',
  fontWeight: 500,
  textAlign: 'center',
  fontFamily: "'Rookery new', sans-serif",
  lineHeight: '1.625rem',
}));

export const TextBody = styled(Typography)(() => ({
  color: '#161c27',
  fontSize: '0.875rem',
  fontWeight: 400,
  fontFamily: "'Rookery new', sans-serif",
  lineHeight: '1.25rem',
  letterSpacing: '0.0156rem',
  whiteSpace: 'pre-wrap',
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
}));
